
import { Component, Vue } from 'vue-property-decorator'
import { Debounce } from '@/core/decorator'
import { fileTypes } from '@/api/commonConfig'
import { Getter } from 'vuex-class'
import { downloadUrl } from '@/utils/util'
import BgComp from '../components/bgComp.vue'
import {
  getIDCardByOCR,
  addIDCard,
  getIDCard,
  getCompanyInfo
} from '@/api/approve'
import { backToBefore, LoginReturnDataDto } from '@/utils/h5ToApp'

@Component({
  name: 'UserInfoForm',
  components: {
    BgComp
  }
})
export default class UserInfoForm extends Vue {
  @Getter companyId: string // 公司编号
  @Getter companyName: string // 公司名称
  @Getter info: any // 登录人信息

  labelWidth = '9em'
  formData = {
    companyName: '', // 公司名称
    unifiedSocialCreditCode: '', // 统一社会信用代码
    name: '', // 姓名
    identityCard: '', // 身份证号码
    success: 0
  }
  // 身份证照片列表
  fileA = null
  fileB = null
  // userId1
  userId1 = ''
  // userInfo
  userInfo = {}
  // 法人
  legalPerson = ''
  active = 1
  isSubmit = false

  get safetyHeight () {
    return this.$store.state.app.safetyHeight
  }

  created() {
    // this.getCompanyDtl()
    this.getCompanyInfo()
    this.getIDCard()
  }
  handleBack() {
    if(this.$route.query.formPage==='h5'){
      console.log('调用h5');
      this.$router.back()
    }else {
      console.log('调用原生')
      backToBefore()
    }
  }
  uploadIDCard(IDCardType) {
    if (this.formData.success === 1) {
      this.$toast('当前账号已完成个人实名认证,不可更改身份证信息')
      return
    }
    const data = {
      companyId: this.companyId,
      // 上传文件类别 1公司log 2商品轮播图 3商品推荐图 4商品视频 5商品内容HTML文件 6订单附件 8身份证
      fileType: fileTypes.idCard
    }
    this.$bridge.callHandler('uploadFile', data, (res) => {
      const data = !res ? {} : JSON.parse(res)
      this[`file${IDCardType}`] = data.filePath
      this.$toast({message:'已上传成功，正在识别身份信息…', duration:0})
      this.getIDCardByOCR(IDCardType)
    })
  }
  // 身份证信息识别
  getIDCardByOCR(IDCardType) {
    let params = {
      companyId: this.companyId, // 当前公司
      // 身份证照片 A正面，B反面
      cardType: IDCardType,
      // 身份证文件地址
      fileUrl: this[`file${IDCardType}`]
    }
    getIDCardByOCR(params).then((res) => {
      this.$toast.clear()
      console.log('res userApprove', res)
      if (IDCardType === 'A') {
        this.formData.name = res.data.name
        this.formData.identityCard = res.data.idcard
        this.userId1 = res.data.userId1
        this.userInfo = res.data
      } else {
        this.userInfo = Object.assign(this.userInfo, res.data)
      }
    }) .catch((res) => {
        console.log('catch', res)
        if (IDCardType === 'A') {
          this.formData.name = ''
          this.formData.identityCard = ''
          this.fileA = ''
        } else {
          this.fileB = ''
        }
      })
  }
  // 获取身份信息
  getIDCard() {
    let params = {
      companyId: this.companyId
    }
    getIDCard(params).then((res) => {
      console.log('res', res)
      if (res.data) {
        this.formData.name = res.data.name
        this.formData.identityCard = res.data.idCard
        this.fileA = res.data.fileUrlA
        this.fileB = res.data.fileUrlB
        this.formData.success = res.data.success
      }
    })
  }
  // 获取公司信息
  getCompanyInfo() {
    let params = {
      companyId: this.companyId
    }
    getCompanyInfo(params).then((res) => {
      console.log('getCompanyInfo', res.data)
      this.formData.unifiedSocialCreditCode = res.data.unifiedSocialCreditCode
      this.formData.companyName = res.data.companyName
      this.legalPerson = res.data.legalPerson
    })
  }
  // 提交
  @Debounce(500) // 防抖
  submit() {
    if (this.info.isIdentification == '1' && this.info.userOtherType == '1') {
      this.$toast(
        '您在' + this.companyName + '已认证为法定代表人，请勿重复认证'
      )
      return
    }
    this.addIDCard()
  }
  // 保存/更新身份信息
  addIDCard() {
    let params = {
      companyId: this.companyId,
      ...this.formData,
      ...this.userInfo,
      fileUrlA: this.fileA,
      fileUrlB: this.fileB
    }
    addIDCard(params)
      .then((res) => {
        console.log('res', res)
        if (res.code === '000000') {
          this.handleForm()
        } else {
          this.$dialog
            .alert({
              title: '查询结果',
              message: res.msg
            })
            .then(() => {})
        }
      })
      .catch((res) => {
        console.log('catch', res)
      })
  }
  handleForm() {
    if (!this.fileA || !this.fileB) {
      this.$toast('请上传身份证照片')
      return
    }
    if (this.isSubmit) return false
    ;(this.$refs.userInfoForm as any)
      .validate()
      .then(() => {
        this.isSubmit = true
        this.$confirmDialog.show({
          okText: '确认',
          cancelText: '取消',
          tips: `我们将自动匹配您在${this.companyName}的身份信息，请确定为本人操作`,
          onOk: () => {
            this.$router.push({
              path: '/faceConfirm',
              query: {
                title: '身份认证',
                flag: 'user',
                unifiedSocialCreditCode: this.formData.unifiedSocialCreditCode
              }
            })
          }
        })
      })
      .catch(() => {})
      .finally(() => {
        this.isSubmit = false
      })
  }
}
